<template>
    <div class="school-dynamics">
        <div class="school-dynamics-content">
             <!-- @mouseover="hoverEvent" @mouseout="mouseleaveEvent"  -->
            <div class="data-list" id="dynamic-ul" ref="dynamicUl">
                <div class="data-box" v-for="(item,index) in dataList" :key="index">
                    <div class="data-box-item" v-for="(sitem,sindex) in item.list" :key="sindex" :style="sindex % 2 == 0 ? `margin-left:${sitem.left}px` : `margin-right:${sitem.left}px`">
                        <div class="title">
                            {{ getSourceByType(sitem.type) }}  {{ sitem.operationTime }}
                        </div>
                        <div class="info" :title="sitem.operation">
                            {{ sitem.operation }}
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <img class="center-background" :src="require('@/assets/images/sydataboard/center-bg.png')" alt="">
        <img class="left-background" :src="require('@/assets/images/sydataboard/left-bg.png')" alt="">
        <img class="right-background" :src="require('@/assets/images/sydataboard/right-bg.png')" alt="">
    </div>
</template>
<script>
import CountUp from "@/components/countUp.vue";
export default {
  name: 'school-dynamics',
  components: {
    CountUp, //数据卡片
  },
  props:{

  },
  data() {
    return {
        dataList:[
    {
        "list": [
            {
                "type": 2,
                "id": "226d83c2815648a09409af79965ec932",
                "operation": "朱志英教师上传了一份资源",
                "realname": "朱志英",
                "operationTime": "2023-08-31 10:08",
                "left": 0
            },
            {
                "type": 2,
                "id": "0a1743208476452e8a63b14fbbf8dcd1",
                "operation": "朱志英教师上传了一份资源",
                "realname": "朱志英",
                "operationTime": "2023-08-31 10:07",
                "left": 0
            }
        ]
    },
    {
        "list": [
            {
                "type": 8,
                "id": "bd1b096214a94d6bae9bfc009e53fe39",
                "operation": "施军钿老师发布公告《省教育技术论文评选参考指标》",
                "realname": "施军钿",
                "operationTime": "2023-08-29 16:46",
                "left": 30
            },
            {
                "type": 8,
                "id": "86b5d7ded4284a50a1f903c353c7822b",
                "operation": "施军钿老师发布公告《省教育技术论文报关要求》",
                "realname": "施军钿",
                "operationTime": "2023-08-29 16:45",
                "left": 30
            }
        ]
    },
    {
        "list": [
            {
                "type": 8,
                "id": "9e3905399dae4a4c987676fc5b59ea28",
                "operation": "施军钿老师发布公告《浙江省教育技术中心关于组织开展2023年全省中小学教师教育技术论文活动的通知》",
                "realname": "施军钿",
                "operationTime": "2023-08-29 16:45",
                "left": 60
            },
            {
                "type": 8,
                "id": "c85d7ed143aa4e3881c8d57f8585b905",
                "operation": "施军钿老师发布成果《央馆虚拟实验培训师证书》",
                "realname": "施军钿",
                "operationTime": "2023-08-26 11:10",
                "left": 60
            }
        ]
    },
    {
        "list": [
            {
                "type": 11,
                "id": "8f705b52a22c469192725883bc7f40be",
                "operation": "张科君老师报名参与教研活动《新八年级电学探究活动    师大上虞附中》",
                "realname": "张科君",
                "operationTime": "2023-08-25 19:59",
                "left": 30
            },
            {
                "type": 2,
                "id": "d1e9146fd5aa4fec89af636ad2e21e24",
                "operation": "方玉君教师上传了一份资源",
                "realname": "方玉君",
                "operationTime": "2023-08-23 20:22",
                "left": 30
            }
        ]
    },
    {
        "list": [
            {
                "type": 2,
                "id": "6a0ad52c8972434bb543829190363544",
                "operation": "方玉君教师上传了一份资源",
                "realname": "方玉君",
                "operationTime": "2023-08-23 20:22",
                "left": 0
            },
            {
                "type": 2,
                "id": "805b94d6ceff4a89a47bc2b17c80acec",
                "operation": "方玉君教师上传了一份资源",
                "realname": "方玉君",
                "operationTime": "2023-08-23 07:39",
                "left": 0
            }
        ]
    },
    {
        "list": [
            {
                "type": 2,
                "id": "bbdd9e948fd44f179c67b04fea962b66",
                "operation": "方玉君教师上传了一份资源",
                "realname": "方玉君",
                "operationTime": "2023-08-23 07:39",
                "left": 30
            },
            {
                "type": 2,
                "id": "a7052aaa3fed47a59edb2442c1e77bbc",
                "operation": "张继德教师上传了一份资源",
                "realname": "张继德",
                "operationTime": "2023-07-20 14:49",
                "left": 30
            }
        ]
    },
    {
        "list": [
            {
                "type": 2,
                "id": "3440dadb8e5645998d292026299b8cf5",
                "operation": "张继德教师上传了一份资源",
                "realname": "张继德",
                "operationTime": "2023-04-20 12:49",
                "left": 60
            },
            {
                "type": 2,
                "id": "860b7e96cdde4e29a5e24388237b8cf7",
                "operation": "施军钿教师上传了一份资源",
                "realname": "张继德",
                "operationTime": "2023-06-21 13:49",
                "left": 60
            }
        ]
    },
    {
        "list": [
            {
                "type": 2,
                "id": "22006d78aaab4542ab2daad27433f507",
                "operation": "张继德教师上传了一份资源",
                "realname": "张继德",
                "operationTime": "2023-07-22 14:09",
                "left": 30
            },
            {
                "type": 2,
                "id": "950c26c580474f1fbf1737967f0ab9e4",
                "operation": "施军钿教师上传了一份资源",
                "realname": "张继德",
                "operationTime": "2023-08-21 9:49",
                "left": 30
            }
        ]
    },
    {
        "list": [
            {
                "type": 2,
                "id": "7b4253fa44f84eca9e13b749fb1a2869",
                "operation": " 张继德教师上传了一份资源",
                "realname": "张继德",
                "operationTime": "2023-08-12 12:21",
                "left": 60
            },
            {
                "type": 2,
                "id": "4118af322c76479d8893b2d93875905b",
                "operation": " 施军钿教师上传了一份资源",
                "realname": "张继德",
                "operationTime": "2023-08-02 12:12",
                "left": 60
            }
        ]
    },
    {
        "list": [
            {
                "type": 2,
                "id": "abefe8a158f24ca992a62238da5a8dcf",
                "operation": "张继德教师上传了一份资源",
                "realname": "张继德",
                "operationTime": "2023-08-11 11:11",
                "left": 0
            },
            {
                "type": 2,
                "id": "938eb4043b5d44bd94acc8b24d5beeb5",
                "operation": "施军钿教师上传了一份资源",
                "realname": "张继德",
                "operationTime": "2023-08-20 10:10",
                "left": 0
            }
        ]
    },
    {
        "list": [
            {
                "type": 2,
                "id": "8516d06609954c8d80e10701ac2d6b8e",
                "operation": "张继德教师上传了一份资源",
                "realname": "张继德",
                "operationTime": "2023-08-21 19:49",
                "left": 30
            },
            {
                "type": 2,
                "id": "e3602c760bd4411dbeaa9e57e4b1a912",
                "operation": "施军钿教师上传了一份资源",
                "realname": "张继德",
                "operationTime": "2023-08-29 11:18",
                "left": 30
            }
        ]
    },
    {
        "list": [
            {
                "type": 2,
                "id": "45d8be51bd2443b0b00577fb20bcde21",
                "operation": "张继德教师上传了一份资源",
                "realname": "张继德",
                "operationTime": "2023-08-22  12:48",
                "left": 60
            },
            {
                "type": 2,
                "id": "5fbcc07f1ce7408482eaac78e0494603",
                "operation": " 施军钿教师上传了一份资源",
                "realname": "张继德",
                "operationTime": "2023-08-02 9:30",
                "left": 60
            }
        ]
    },
    {
        "list": [
            {
                "type": 2,
                "id": "91458c2a973a4ae9a749986f29b23796",
                "operation": " 张继德教师上传了一份资源",
                "realname": "张继德",
                "operationTime": "2023-08-02 14:33",
                "left": 0
            },
            {
                "type": 2,
                "id": "e2df14ec4061456bb88238f9e7ab9d67",
                "operation": " 施军钿教师上传了一份资源",
                "realname": "张继德",
                "operationTime": "2023-08-21 10:39",
                "left": 0
            }
        ]
    },
    {
        "list": [
            {
                "type": 2,
                "id": "c8b9d70a658c43e0a12f7f9a216f1bc5",
                "operation": "张继德教师上传了一份资源",
                "realname": "张继德",
                "operationTime": "2023-08-12 13:39",
                "left": 30
            },
            {
                "type": 2,
                "id": "03649cd8641f475499d7159119d81098",
                "operation": "施军钿教师上传了一份资源",
                "realname": "张继德",
                "operationTime": "2023-08-22 16:39",
                "left": 30
            }
        ]
    },
    {
        "list": [
            {
                "type": 2,
                "id": "499132aa38564730a6c8106b198c8ada",
                "operation": "张继德教师上传了一份资源",
                "realname": "张继德",
                "operationTime": "2023-08-01 11:39",
                "left": 60
            },
            {
                "type": 2,
                "id": "a0453fe514964fbf8b05c875284e8958",
                "operation": "施军钿教师上传了一份资源",
                "realname": "张继德",
                "operationTime": "2023-08-04 14:39",
                "left": 60
            }
        ]
    },
    {
        "list": [
            {
                "type": 2,
                "id": "c8b9d70a658c43e0a12f7f9a216f1bc5",
                "operation": "张继德教师上传了一份资源",
                "realname": "张继德",
                "operationTime": "2023-08-07 14:39",
                "left": 30
            },
            {
                "type": 2,
                "id": "03649cd8641f475499d7159119d81098",
                "operation": "张继德教师上传了一份资源",
                "realname": "张继德",
                "operationTime": "2023-08-12 14:39",
                "left": 30
            }
        ]
    },
    {
        "list": [
            {
                "type": 2,
                "id": "226d83c2815648a09409af79965ec932",
                "operation": "朱志英教师上传了一份资源",
                "realname": "朱志英",
                "operationTime": "2023-08-31 10:08",
                "left": 0
            },
            {
                "type": 2,
                "id": "0a1743208476452e8a63b14fbbf8dcd1",
                "operation": "朱志英教师上传了一份资源",
                "realname": "朱志英",
                "operationTime": "2023-08-31 10:07",
                "left": 0
            }
        ]
    },
    {
        "list": [
            {
                "type": 8,
                "id": "bd1b096214a94d6bae9bfc009e53fe39",
                "operation": "施军钿老师发布公告《省教育技术论文评选参考指标》",
                "realname": "施军钿",
                "operationTime": "2023-08-29 16:46",
                "left": 30
            },
            {
                "type": 8,
                "id": "86b5d7ded4284a50a1f903c353c7822b",
                "operation": "施军钿老师发布公告《省教育技术论文报关要求》",
                "realname": "施军钿",
                "operationTime": "2023-08-29 16:45",
                "left": 30
            }
        ]
    },
    {
        "list": [
            {
                "type": 8,
                "id": "9e3905399dae4a4c987676fc5b59ea28",
                "operation": "施军钿老师发布公告《浙江省教育技术中心关于组织开展2023年全省中小学教师教育技术论文活动的通知》",
                "realname": "施军钿",
                "operationTime": "2023-08-29 16:45",
                "left": 60
            },
            {
                "type": 8,
                "id": "c85d7ed143aa4e3881c8d57f8585b905",
                "operation": "施军钿老师发布成果《央馆虚拟实验培训师证书》",
                "realname": "施军钿",
                "operationTime": "2023-08-26 11:10",
                "left": 60
            }
        ]
    },
    {
        "list": [
            {
                "type": 11,
                "id": "8f705b52a22c469192725883bc7f40be",
                "operation": "张科君老师报名参与教研活动《新八年级电学探究活动    师大上虞附中》",
                "realname": "张科君",
                "operationTime": "2023-08-25 19:59",
                "left": 30
            },
            {
                "type": 2,
                "id": "d1e9146fd5aa4fec89af636ad2e21e24",
                "operation": "方玉君教师上传了一份资源",
                "realname": "方玉君",
                "operationTime": "2023-08-23 20:22",
                "left": 30
            }
        ]
    },
    {
        "list": [
            {
                "type": 2,
                "id": "6a0ad52c8972434bb543829190363544",
                "operation": "方玉君教师上传了一份资源",
                "realname": "方玉君",
                "operationTime": "2023-08-23 20:22",
                "left": 0
            },
            {
                "type": 2,
                "id": "805b94d6ceff4a89a47bc2b17c80acec",
                "operation": "方玉君教师上传了一份资源",
                "realname": "方玉君",
                "operationTime": "2023-08-23 07:39",
                "left": 0
            }
        ]
    },
    {
        "list": [
            {
                "type": 2,
                "id": "bbdd9e948fd44f179c67b04fea962b66",
                "operation": "方玉君教师上传了一份资源",
                "realname": "方玉君",
                "operationTime": "2023-08-20 07:39",
                "left": 30
            },
            {
                "type": 2,
                "id": "a7052aaa3fed47a59edb2442c1e77bbc",
                "operation": "张继德教师上传了一份资源",
                "realname": "张继德",
                "operationTime": "2023-08-17 14:49",
                "left": 30
            }
        ]
    },
    {
        "list": [
            {
                "type": 2,
                "id": "3440dadb8e5645998d292026299b8cf5",
                "operation": "张继德教师上传了一份资源",
                "realname": "张继德",
                "operationTime": "2023-08-18 14:49",
                "left": 60
            },
            {
                "type": 2,
                "id": "860b7e96cdde4e29a5e24388237b8cf7",
                "operation": "张继德教师上传了一份资源",
                "realname": "张继德",
                "operationTime": "2023-08-12 14:49",
                "left": 60
            }
        ]
    },
    {
        "list": [
            {
                "type": 2,
                "id": "22006d78aaab4542ab2daad27433f507",
                "operation": "张继德教师上传了一份资源",
                "realname": "张继德",
                "operationTime": "2023-08-22 14:49",
                "left": 30
            },
            {
                "type": 2,
                "id": "950c26c580474f1fbf1737967f0ab9e4",
                "operation": "张继德教师上传了一份资源",
                "realname": "张继德",
                "operationTime": "2023-08-21 14:49",
                "left": 30
            }
        ]
    },
    {
        "list": [
            {
                "type": 2,
                "id": "7b4253fa44f84eca9e13b749fb1a2869",
                "operation": "张继德教师上传了一份资源",
                "realname": "张继德",
                "operationTime": "2023-08-23 14:49",
                "left": 60
            },
            {
                "type": 2,
                "id": "4118af322c76479d8893b2d93875905b",
                "operation": "张继德教师上传了一份资源",
                "realname": "张继德",
                "operationTime": "2023-08-24 14:49",
                "left": 60
            }
        ]
    },
    {
        "list": [
            {
                "type": 2,
                "id": "abefe8a158f24ca992a62238da5a8dcf",
                "operation": "张继德教师上传了一份资源",
                "realname": "张继德",
                "operationTime": "2023-08-22 14:49",
                "left": 0
            },
            {
                "type": 2,
                "id": "938eb4043b5d44bd94acc8b24d5beeb5",
                "operation": "张继德教师上传了一份资源",
                "realname": "张继德",
                "operationTime": "2023-08-22 14:49",
                "left": 0
            }
        ]
    },
    {
        "list": [
            {
                "type": 2,
                "id": "8516d06609954c8d80e10701ac2d6b8e",
                "operation": "张继德教师上传了一份资源",
                "realname": "张继德",
                "operationTime": "2023-08-22 14:49",
                "left": 30
            },
            {
                "type": 2,
                "id": "e3602c760bd4411dbeaa9e57e4b1a912",
                "operation": "张继德教师上传了一份资源",
                "realname": "张继德",
                "operationTime": "2023-08-22 14:48",
                "left": 30
            }
        ]
    },
    {
        "list": [
            {
                "type": 2,
                "id": "45d8be51bd2443b0b00577fb20bcde21",
                "operation": "张继德教师上传了一份资源",
                "realname": "张继德",
                "operationTime": "2023-08-22 14:48",
                "left": 60
            },
            {
                "type": 2,
                "id": "5fbcc07f1ce7408482eaac78e0494603",
                "operation": "张继德教师上传了一份资源",
                "realname": "张继德",
                "operationTime": "2023-08-22 14:39",
                "left": 60
            }
        ]
    },
    {
        "list": [
            {
                "type": 2,
                "id": "91458c2a973a4ae9a749986f29b23796",
                "operation": "张继德教师上传了一份资源",
                "realname": "张继德",
                "operationTime": "2023-08-22 14:39",
                "left": 0
            },
            {
                "type": 2,
                "id": "e2df14ec4061456bb88238f9e7ab9d67",
                "operation": "张继德教师上传了一份资源",
                "realname": "张继德",
                "operationTime": "2023-08-22 14:39",
                "left": 0
            }
        ]
    },
    {
        "list": [
            {
                "type": 2,
                "id": "c8b9d70a658c43e0a12f7f9a216f1bc5",
                "operation": "张继德教师上传了一份资源",
                "realname": "张继德",
                "operationTime": "2023-08-22 14:39",
                "left": 30
            },
            {
                "type": 2,
                "id": "03649cd8641f475499d7159119d81098",
                "operation": "张继德教师上传了一份资源",
                "realname": "张继德",
                "operationTime": "2023-08-22 14:39",
                "left": 30
            }
        ]
    },
    {
        "list": [
            {
                "type": 2,
                "id": "499132aa38564730a6c8106b198c8ada",
                "operation": "张继德教师上传了一份资源",
                "realname": "张继德",
                "operationTime": "2023-08-22 14:39",
                "left": 60
            },
            {
                "type": 2,
                "id": "a0453fe514964fbf8b05c875284e8958",
                "operation": "张继德教师上传了一份资源",
                "realname": "张继德",
                "operationTime": "2023-08-22 14:39",
                "left": 60
            }
        ]
    },
    {
        "list": [
            {
                "type": 2,
                "id": "c8b9d70a658c43e0a12f7f9a216f1bc5",
                "operation": "张继德教师上传了一份资源",
                "realname": "张继德",
                "operationTime": "2023-08-22 14:39",
                "left": 30
            },
            {
                "type": 2,
                "id": "03649cd8641f475499d7159119d81098",
                "operation": "张继德教师上传了一份资源",
                "realname": "张继德",
                "operationTime": "2023-08-22 14:39",
                "left": 30
            }
        ]
    }
],
        scrollInterval: {
            minTop:0,
            maxTop:0
        },//动态滚动区间,
        scrollIngDynamicList: [],
        timer: null,
        numberList:[
            {
                name:"建设总量",
                value:38975
            },
            {
                name:"分享总量",
                value:68692
            },
            {
                name:"引用总量",
                value:124808
            }
        ]
    }
  },
  methods: {
    /**
     * @name 获取来源
     */
     getSourceByType(type){
        let name = ''
        switch(type){
            case 1:
                name = '作业';
                break;
            case 2:
                name = '资源';
                break;
            case 3:
                name = '评价';
                break;
            case 4:
                name = '互动';
                break;
            case 6:
                name = '题库';
                break;
            case 7:
                name = '活动评审';
                break;
            case 8:
                name = '名师工作室';
                break;
            case 9:
                name = '集体备课';
                break;
            case 10:
                name = '听评课';
                break;
            case 11:
                name = '特色活动';
                break;
            case 12:
                name = '在线课程';
                break;
        }
        return name
    },
  },
  mounted() {
    
  }
}
</script>
<style lang="scss" scoped>
.school-dynamics{
    width: 100%;
    height: 480px;
    position: relative;
    overflow: hidden;
    // margin-bottom: 20px;
    .school-dynamics-content{
        width: calc(100% - 60px);
        height: calc(100% - 40px);
        position: relative;
        overflow: hidden;
        margin: 20px auto;
        .data-list{
            width: 100%;
            // height: auto;
            display: flex;
            flex-direction: column;
            align-items: center;
            margin: 0 auto;
            // justify-content: center;
            position: relative;
            z-index: 2;
        }
        #dynamic-ul {
            &.data-box {
                cursor: pointer;
            }

            // height: 100%;
            animation: infinitevertical 30s linear infinite;

            &:hover {
                animation-play-state: paused;
            }

        }
        .data-box{
            width: 100%;
            display: flex;
            align-items: center;
            justify-content: space-between;
            position: relative;
            z-index: 2;
            margin-bottom: 65px;
            // margin: 20px 0;
            .data-box-item{
                display: inline-block;
                width: 250px;
                // padding: 0 10px;
                padding: 0 15px;
                color: #FFFFFF;
                text-align: left;
                position: relative;
                cursor: pointer;
                background: linear-gradient(-2deg, #2465CF 0%, transparent 60%);
                .title{
                    font-size: 12px;
                    font-family: Microsoft YaHei;
                    font-weight: 400;
                    color: #FFFFFF;
                    margin-bottom: 10px;
                }
                .info{
                    font-size: 14px;
                    font-family: Microsoft YaHei;
                    font-weight: 400;
                    color: #FFFFFF;
                    width: 100%;
                    white-space: nowrap;
                    overflow: hidden;
                    text-overflow: ellipsis;
                }
                &:hover{
                    background: linear-gradient(0deg, #D88815 0%, #0C1947 100%);
                }
            }
        }
    }
    .center-background{
        height: calc(100% - 50px);
        width: auto;
        position: absolute;
        left: 50%;
        transform: translateX(-50%);
        bottom: 10px;
    }
    .left-background{
        width: auto;
        height: calc(100% - 50px);
        position: absolute;
        top: 0;
        left: -5px;
    }
    .right-background{
        width: auto;
        height: calc(100% - 50px);
        position: absolute;
        top: 0;
        right: -5px;
    }
    .top-left{
        position: absolute;
        top: 0;
        left: 0;
        width: 14px;
        height: 14px;
    }
    .right-bottom{
        position: absolute;
        bottom: 0;
        right: 0;
        width: 14px;
        height: 14px;
    }
}
/* 无限滚动垂直 */
@keyframes infinitevertical {
    0% {
        transform: translateY(0%);
    }

    100% {
        transform: translateY(-50%);
    }
}
</style>
<style lang="scss">
</style>